export default __webpack_public_path__ + "static/media/juniorGameDeveloper.9e9762cc.png";